import { z } from "zod";

import { schemes } from "../schema-validation";
import { baseEventInput } from "./baseEvent";
import { companyOnboardingTaskStatusSchema } from "./companyOnboardingEvent";

export const partnerOnboardingEvent = baseEventInput.merge(
  z.object({
    source: z.literal("whitelabel.onboarding"),
    whiteLabelId: schemes.uuid(),
    taskDefinitionId: schemes.uuid(),
    payload: z
      .object({
        businessDetails: companyOnboardingTaskStatusSchema,
        businessDocuments: companyOnboardingTaskStatusSchema,
        ownershipDetails: companyOnboardingTaskStatusSchema,
        agreements: companyOnboardingTaskStatusSchema,
        securityDetails: companyOnboardingTaskStatusSchema,
      })
      .partial(),
  })
);

export type PartnerOnboardingEvent = z.infer<typeof partnerOnboardingEvent>;
